import { Button } from "@decibeltrade/web-core/components";
import { ModalContent, ModalRenderProps, openModal } from "@decibeltrade/web-core/modal";
import { useTranslations } from "next-intl";
import { css } from "styled-system/css";
import { flex, stack } from "styled-system/patterns";

import { ModalCloseButton } from "./modal-close-button";

export interface CopyWarningModalProps {
  warningMessage: string;
  valueToCopy: string;
  onConfirm: () => void;
}

export function openCopyWarningModal(props: CopyWarningModalProps) {
  openModal({
    id: "copy-warning-modal",
    renderContent: (modalProps) => <CopyWarningModal {...modalProps} {...props} />,
  });
}

function CopyWarningModal({
  close,
  warningMessage,
  valueToCopy,
  onConfirm,
}: ModalRenderProps & CopyWarningModalProps) {
  const t = useTranslations("general");

  const handleConfirm = async () => {
    try {
      await navigator.clipboard.writeText(valueToCopy);
      onConfirm();
      close();
    } catch {
      // Intentionally no-op; avoid noisy UI on permission errors
    }
  };

  return (
    <ModalContent className={stack({ w: "448", gap: "24" })}>
      <ModalCloseButton close={close} />

      <div className={stack({ gap: "12" })}>
        <h2 className={modalHeaderStyles}>{t("warning")}</h2>
        <p className={descriptionStyles}>{warningMessage}</p>
      </div>

      <div className={flex({ gap: "8" })}>
        <Button variant="secondary" fullWidth onClick={close}>
          {t("cancel")}
        </Button>
        <Button fullWidth onClick={handleConfirm}>
          {t("copyAddress")}
        </Button>
      </div>
    </ModalContent>
  );
}

const modalHeaderStyles = css({ textStyle: "heading.3xs", color: "text.secondary" });

const descriptionStyles = css({ textStyle: "body.md", color: "text.tertiary" });
